module.exports = "<alg-icon id=\"info-icon\" *ngIf=\"cornerIcon\" icon=\"info\" (click)=\"openDropdownInfo()\" ></alg-icon>\n  <div [class.visible]=\"isOpenInfo\" class=\"wrapper-content-info\">\n    <ng-content></ng-content>\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/molecules/alg-info-tooltip/alg-info-tooltip.component.html
// module id = ./src/app/components/molecules/alg-info-tooltip/alg-info-tooltip.component.html
// module chunks = main